import React from 'react';

import { Typography } from '../../../DesignSystem';

import {
    Caption,
    ChildrenWrapper,
    IconButtonBackgroundBorder,
    IconContainer,
    type IconSize,
    StyledIconButton,
} from './styles';

interface Props {
    onClick: (event?: React.MouseEvent<HTMLElement>) => void;
    imgSrc?: string;
    rotate?: boolean;
    caption?: string;
    size?: IconSize;
    rounded?: boolean;
    primary?: boolean;
    disabled?: boolean;
    secondary?: boolean;
    active?: boolean;
    children?: React.ReactElement;
}

const IconButton: React.FC<Props> = ({
    onClick,
    imgSrc,
    rotate,
    size,
    rounded,
    primary,
    secondary,
    disabled,
    active,
    children,
    caption,
}) => {
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        onClick(event);
    };
    return (
        <IconButtonBackgroundBorder
            onClick={handleClick}
            $size={size || 'large'}
            $secondary={!!(secondary && children)}
            $primary={primary}
            $active={active}
            $disabled={disabled}
        >
            {imgSrc && <StyledIconButton $rounded={rounded} $rotate={rotate} src={imgSrc} />}
            {children && (
                <ChildrenWrapper $rounded={rounded} $rotate={rotate}>
                    {children}
                </ChildrenWrapper>
            )}
            <IconContainer />
            {caption && !active && (
                <Caption>
                    <Typography color="inherit" size={12} type="paragraph" weight="700">
                        {caption}
                    </Typography>
                </Caption>
            )}
        </IconButtonBackgroundBorder>
    );
};

export default IconButton;
